<template>
	<div
		class="position-relative select w-100 d-flex align-items-center"
		:class="{
			opened: open,
		}"
		:style="{
			height: '47px',
			color: open ? 'black' : color
		}"
	>
		<div
			class="select--line d-flex justify-content-center align-items-center w-100"
			@click="open = !open"
		>
			<div
				v-if="$slots.beforeSelected"
				class="d-flex ml-auto icon"
				:class="{
					rotate: open,
				}"
			>
				<slot
					name="beforeSelected"
					:class="{
						rotate: open,
					}"
				></slot>
			</div>
			error:call:29
			<div
				v-if="$slots.afterSelected"
				class="d-flex ml-auto icon"
				:class="{
					rotate: open,
				}"
			>
				<slot
					name="afterSelected"
				></slot>
			</div>
		</div>

		<transition-group
			v-if="isOpen"
			name="fade"
			tag="div"
			class="options position-absolute"
		>
			<div
				v-for="(item) in items"
				:key="item.name"
				class="select--item d-flex align-items-center w-100 px-3"
				@click="itemSelected(item.name)"
			>
				
			</div>
		</transition-group>
	</div>
</template>

<script>
export default {
	name: "BaseCrossPlatformDropdown",
	props: {
		items: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: 'label'
		},
		value: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: 'black'
		},
		rotateIcon: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpen: false
		}
	},
	computed: {
		open: {
			get () {
				return this.isOpen;
			},
			set(val) {
				this.isOpen = val
			}
		}
	},
	methods: {
		toggleOpentoggleOpen() {
			this.open = !this.open
			console.log('open', this.open)
		},
		itemSelected (itemName) {
			this.$emit('input', itemName);
			this.open = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.select--line {
	cursor: pointer;
}

.select--item {
	border: solid 1px white;
	border-top: solid 1px #d8d8d8;
	z-index: 1020;
	width: 100%;
	height: auto;
	transition: all .3s ease;
	background-color: white;
	color: black;
	cursor: pointer;
	padding-top: 10px;
	padding-bottom: 10px;
}

.select {
	border: solid 1px white;
	width: 100%;
	height: 100%;
	transition: all .3s ease;
}

.select.opened {
	background-color: white;
	color: black;

	svg path,
	svg polygon {
		fill: black;
	}
}

.icon {
	transform: rotate(0deg);
	transform-origin: center;
	transition: transform .3s ease-in-out;
}

.rotate {
	transform: rotate(180deg);
	transition: transform .3s ease-in-out;
}

.options {
	top: 100%;
	left: -1px;
	right: -1px;
	z-index: 1010;
	max-height: 355px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track-piece  {
		background-color: rgba(255, 91, 0, 0.4);
	}

	&::-webkit-scrollbar-thumb:vertical {
		height: 30px;
		background-color: #E75300;
	}

	&::-webkit-scrollbar-track  {
		background-color: #C2D2E4;
	}

	&::-webkit-scrollbar-thumb {
		height: 30px;
		width: 10px;
		background-color: #E75300;
		border-radius: 15px;
	}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
